import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Button extends React.PureComponent {
  state = {
    active: false
  }

  deactivateButton = () => this.setState({ active: false })

  activateButton = () => this.setState({ active: true })

  render() {
    const { className, selected, ...props } = this.props;
    const { active } = this.state;
    return (
      <button
        {...props}
        className={classNames(
          className,
          'btn',
          { 'btn-active': active || selected }
        )}
        onMouseEnter={this.activateButton}
        onMouseLeave={this.deactivateButton}
        onTouchStart={this.activateButton}
        onTouchEnd={this.deactivateButton}
        onTouchCancel={this.deactivateButton}
        onDragEnd={this.deactivateButton}
      />
    );
  }
}

Button.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool.isRequired
};

Button.defaultProps = {
  className: '',
  selected: false
};

export default Button;



// WEBPACK FOOTER //
// ./app/components/Button.js